export default (model) => {
  if (window.fbq)
    window.fbq('track', 'Purchase', {
      value: Number(model.totalAmount),
      currency: model.currencyCode,
    });
};
